import React from 'react';
import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import { Box } from '../design/css';

const FiltersButtons = ({ onApplyFilters, onResetFilters, buttonLabels }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="row"
      pt={64}
      mdJustifyContent="flex-start"
      mdWidth={100}
      mdPadding="16px 0"
      margin="0 auto"
    >
      <Button onClick={onResetFilters}>{buttonLabels.reset}</Button>
      <Box width="2"> </Box>
      <Button onClick={onApplyFilters} variant="secondary">
        {buttonLabels.apply}
      </Button>
    </Box>
  );
};

FiltersButtons.propTypes = {
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  buttonLabels: PropTypes.shape({
    apply: PropTypes.string.isRequired,
    reset: PropTypes.string.isRequired
  }).isRequired
};

export default FiltersButtons;
